// extracted by mini-css-extract-plugin
export var button = "_bq-4";
export var hasDarkBackground = "_bq-7";
export var hasLightBackground = "_bq-6";
export var iconWrapper = "_bq-0";
export var large = "_bq-2";
export var medium = "_bq-1";
export var small = "_bq-5";
export var xsmall = "_bq-3";